var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-navigation"},_vm._l((_vm.tabs),function(t){return _c('div',{staticClass:"order-navigation-button",class:{
			active: _vm.tab == t.id,
			finished: _vm.finished[t.id],
			disabled: _vm.disabled[t.id],
		},on:{"click":function($event){return _vm.setTab(t.id)}}},[_c('div',[_c('SvgIcon',{attrs:{"name":t.icon}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(t.name))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }